
export const cricketData = [
    {
        date: '15-Sep 03:30pm',
        teams: 'Zimbabwe v South Africa',
        tags: ['F', 'BM'],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88',],
        live: true, // Game is live
    },
    {
        date: '15-Sep 03:30pm',
        teams: 'Zimbabwe v South Africa',
        tags: ['F', 'BM'],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
        live: false, // Game is not live
    },
    // ... Add more
];

export const footballData = [
    {
        date: '15-Sep 03:30pm',
        teams: 'Alexander Mark vs Oluwafikayomi Oluwadamilola',
        tags: ['BM'],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
        live: true, // Game is live
    },
];

export const tennisData = [
    {
        date: '15-Sep 03:30pm',
        teams: 'Novak Djokovic vs Carlos Alcaraz',
        tags: [],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
        live: false, // Game is not live
    },
];


export const kabaddiData = [
    {
        date: '15-Sep 03:30pm',
        teams: 'Telugu Titans vs Dabang Delhi',
        tags: ['F', 'BM'],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
        live: true, // Game is live
    },
];
export const CasinoData = [
    // {
    //     date: '15-Sep 03:30pm',
    //     teams: 'Telugu Titans vs Dabang Delhi',
    //     tags: ['F', 'BM'],
    //     odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
    //     live: true, 
    // },
];
export const electionData = [
    {
        date: '15-Sep 03:30pm',
        teams: 'BJP vs Congress',
        tags: ['F'],
        odds: ['1.87', '1.88', '1.87', '1.88', '1.87', '1.88'],
        live: false, // Game is not live
    },
];
